import React, { useState } from "react";
import { Pagination, Row, Col, Input } from "antd";
function MobilizationPagination({
  currentPage,
  setCurrentPage,
  total,
  itemPerPage,
  selectedAdverts,
  setIsFilterUsing,
}) {
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <a>
          <svg
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 1L1 6L6 11"
              stroke="#1B2444"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      );
    }
    if (type === "next") {
      return (
        <a>
          <svg
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L6 6L1 11"
              stroke="#1B2444"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      );
    }
    return originalElement;
  };
  const [jumpPage, setJumpPage] = useState("");

  const handleJump = () => {
    const page = parseInt(jumpPage, 10);
    if (!isNaN(page) && page >= 1 && page <= Math.ceil(total / itemPerPage)) {
      setCurrentPage(page);
      setJumpPage("");
    }
  };


  //  total === 0 ? 0 : (current - 1) * pageSize + 1,
  //     current * pageSize > total ? total : current * pageSize,
  return (
    <div className="customPagination">
      <Row justify={"end"} align={"middle"}>
        <Col className="subDesc mt-3">
          Rows per page{" "}
          {total ? (
            <span>
              {(currentPage * itemPerPage > total
                ? total
                : currentPage * itemPerPage) %
                itemPerPage ===
              0
                ? itemPerPage
                : (currentPage * itemPerPage > total
                    ? total
                    : currentPage * itemPerPage) % itemPerPage}
            </span>
          ) : (
            "0"
          )}
        </Col>
        <Col>
          <Pagination
            itemRender={itemRender}
            simple
            total={total}
            current={currentPage}
            pageSize={itemPerPage}
            showTotal={(total, range) => (
              <span className="subDesc pageNumbers">
                {range[0]}-{range[1]} of {total}
              </span>
            )}
            onChange={(page) => {selectedAdverts.length > 0 ? setIsFilterUsing(true):setIsFilterUsing(false); setCurrentPage(page)}}
            showTitle={false}
            defaultCurrent={1}
            pageSizeOptions={[10, 20, 30, 40, 100]}
            showQuickJumper={false}
          />
        </Col>
      <Col style={{marginLeft:"10px"}}>
              <Input
              
                size="small"
                placeholder="Go to"
                style={{ width: 60 ,height:32}}
                value={jumpPage}
                onChange={(e) => setJumpPage(e.target.value)}
                onPressEnter={handleJump}
              />
            </Col>
      </Row>
    </div>
  );
}

export default MobilizationPagination;
